<app-loader *ngIf="!results"></app-loader>
<div class="table-wrapper" #wrapperRef [ngClass]="janus">
<br />
<table
  mat-table
  [dataSource]="dataSource"
  matSort
  *ngIf="results?.length && janus"
  [formGroup]="form">



  <ng-container matColumnDef="select">
    <th mat-header-cell  *matHeaderCellDef class="sticky-col" mat-sort-header="select-label"><div class="header-cell header-flex">
            <div class="header-sortable">
              <wm-common-text
      
                [data]="{ text: '' }">
              </wm-common-text>
            </div>
            <button mat-icon-button
              class="header-menu-btn"
              [matMenuTriggerFor]="columnMenu"
              (click)="$event.stopPropagation()">
                <div class="header-menu-icon">
                  <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                </div>
            </button>
          </div></th>

    <td mat-cell *matCellDef="let row" [formGroup]="row" class="sticky-col">


      <mat-checkbox
  *ngIf="allowMultiples"
  formControlName="selected"
  (change)="selectParcel(row)">
</mat-checkbox>

      <a
      mat-button
        *ngIf="!allowMultiples"
        href="javascript:void(0)"
        (click)="selectParcel(row)">
        Select
      </a>

    </td>
  </ng-container>

  <ng-container matColumnDef="parcelId">
    <th mat-header-cell mat-sort-header="parcelId-label" *matHeaderCellDef><div class="header-cell header-flex">
              <wm-common-text
      
                [data]="{ text: 'Parcel ID' }">
              </wm-common-text>
          
            <button
            mat-icon-button
            class="header-menu-btn"
            [matMenuTriggerFor]="columnMenu">
            <div class="header-menu-icon">
              <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
            </div>
          </button>

          </div></th>
    <td mat-cell *matCellDef="let row">
      <div class="row-cell">
              <wm-common-text
                [data]="{ text: row.value.parcel.parcelID }">
              </wm-common-text>
            </div>
     
    </td>
  </ng-container>


  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="address-label"> <div class="header-cell header-flex" ><div mat-sort-header class="header-sortable">
              <wm-common-text
      
                [data]="{ text: 'Address' }">
              </wm-common-text>
            </div>
            <button mat-icon-button
              class="header-menu-btn"
              [matMenuTriggerFor]="columnMenu"
              (click)="$event.stopPropagation()">
                <div class="header-menu-icon">
                  <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                </div>
            </button>
          </div></th>
    <td mat-cell *matCellDef="let row">
      
       <div class="row-cell">
              <wm-common-text
                [data]="{ text: row.value.parcel.address }">
              </wm-common-text>
            </div>
    </td>
  </ng-container>


  <ng-container matColumnDef="city">
    <th mat-header-cell *matHeaderCellDef  mat-sort-header="city-label"><div class="header-cell header-flex"><div mat-sort-header class="header-sortable">
              <wm-common-text
      
                [data]="{ text: 'City' }">
              </wm-common-text>
            </div>
            <button mat-icon-button
              class="header-menu-btn"
              [matMenuTriggerFor]="columnMenu"
              (click)="$event.stopPropagation()">
                <div class="header-menu-icon">
                  <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                </div>
            </button>
          </div></th>
    <td mat-cell *matCellDef="let row">
      

           <div class="row-cell">
              <wm-common-text
                [data]="{ text: row.value.parcel.city }">
              </wm-common-text>
            </div>
    </td>
  </ng-container>


  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="owner-label"><div class="header-cell header-flex" ><div mat-sort-header class="header-sortable">
              <wm-common-text
      
                [data]="{ text: 'Owner Name' }">
              </wm-common-text>
            </div>
            <button mat-icon-button
              class="header-menu-btn"
              [matMenuTriggerFor]="columnMenu"
              (click)="$event.stopPropagation()">
                <div class="header-menu-icon">
                  <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                </div>
            </button>
          </div></th>
    <td mat-cell *matCellDef="let row">

       <div class="row-cell">
              <wm-common-text
                [data]="{ text: row.value.parcel.ownerName }">
              </wm-common-text>
            </div>
    </td>
  </ng-container>


  <ng-container matColumnDef="acres">
    <th mat-header-cell *matHeaderCellDef class="align-right" mat-sort-header="acres-label"><div class="header-cell header-flex" ><div mat-sort-header class="header-sortable">
              <wm-common-text
      
                [data]="{ text: 'Acres' }">
              </wm-common-text>
            </div>
            <button mat-icon-button
              class="header-menu-btn"
              [matMenuTriggerFor]="columnMenu"
              (click)="$event.stopPropagation()">
                <div class="header-menu-icon">
                  <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                </div>
            </button>
          </div></th>
    <td mat-cell *matCellDef="let row" class="align-right">


        <div class="row-cell">
              <wm-common-text
                [data]="{ text:row.value.parcel.acres | number:'1.3-3' }">
              </wm-common-text>
            </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [class.table-active]="row.value.selected">
  </tr>

</table>
<br />
</div>
<mat-menu #columnMenu="matMenu" class="column-settings-menu">
  <div class="settings-header">
    <div class="settings-col">Column Settings</div>
    <div class="settings-col show-col">Show</div>
  </div>

  <div class="settings-divider"></div>

  <div
    class="settings-row"
    *ngFor="let c of allColumns">
    
    <div class="settings-col">
      {{ c.label }}
    </div>

    <div class="settings-col checkbox-col">
      <mat-checkbox
        [checked]="displayedColumns.includes(c.key)"
        (click)="$event.stopPropagation()"
        (change)="toggleColumn(c.key)">
      </mat-checkbox>
    </div>
  </div>
</mat-menu>



<table class="table" *ngIf="results && results.length > 0 && !janus">
  <thead>
    <tr>
      <th scope="col"></th>
      <th scope="col">Parcel ID</th>
      <th scope="col">Address</th>
      <th scope="col">City</th>
      <th scope="col">Owner Name</th>
      <th scope="col" class="align-right">Acres</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody [formGroup]="form">
    <ng-container formArrayName="myparcels">
      <!-- <ng-container *ngFor="let r of results"> -->
      <ng-container
        *ngFor="let parcelControl of myparcels.controls; let i = index"
      >
        <tr
          [ngClass]="{ 'table-active': parcelControl.value.selected }"
          [formGroup]="parcelControl"
        >
          <td>
            <div
              class="custom-control custom-checkbox"
              [hidden]="!allowMultiples"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                formControlName="selected"
                [id]="'pControl' + parcelControl.value.parcelId"
                [value]="parcelControl.value.selected"
                (change)="selectParcel(parcelControl)"
              />
              <label
                class="custom-control-label"
                [for]="'pControl' + parcelControl.value.parcelId"
              ></label>
            </div>

            <a
              href="javascript:void(0)"
              (click)="selectParcel(parcelControl)"
              [hidden]="allowMultiples"
            >
              Select
            </a>
          </td>
          <td>{{ parcelControl.value.parcelId }}</td>
          <td>{{ parcelControl.value.parcel.address }}</td>
          <td>{{ parcelControl.value.parcel.city }}</td>
          <td>{{ parcelControl.value.parcel.ownerName }}</td>
          <td class="align-right">
            {{ parcelControl.value.parcel.acres * 1 | number: '1.3-3' }}
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>

<p *ngIf="results && results.length < 1">No results</p>
